import { useState } from "react";
import styles from "./MobileMenu.module.css";

export default function MobileMenu({handleNavClick}) {
  const [isOpen, setIsOpen] = useState(false);

  const handleClick = (e, section) => {
    setIsOpen(false);
    handleNavClick(e, section)
  }


  return (
    <section className={styles.MobileMenu}>
      <button className={styles.menuButton} onClick={() => setIsOpen(!isOpen)}>
        <img src="/icons/menu.png" alt="menu icon"/>
      </button>

      <div className={`${styles.sideMenu} ${isOpen ? styles.open : ""}`}>
        <button className={styles.closeButton} onClick={() => setIsOpen(false)}>✖</button>
        <nav>
        
                <a href='#home' onClick={(e) => handleClick(e, "home")}>Home</a>
           
                <a href='#about-us' onClick={(e) => handleClick(e, "about-us")}>About</a>
          
                <a href='#gallery' onClick={(e) => handleClick(e, "gallery")}>Gallery</a>
         
                <a href='#trustees-info' onClick={(e) => handleClick(e, "trustees-info")} >Trustees</a>
           
                <a href='#academics' onClick={(e) => handleClick(e, "academics")}>Academics</a>
          
                <a href='#admission'  onClick={(e) => handleClick(e, "admission")}>Admission</a>
          
                <a href='#footer' onClick={(e) => handleClick(e, "footer")}>Contact</a>
         
                <div className={styles.schoolLink}>
                  <a href="/hangeshwarPublicSchool">
                    Hangeshwar Public School
                  </a>
                </div>
        </nav>
      </div>
    </section>
  );
}
